<template>
    <b-modal v-model="modal_image.show"
             hide-footer
             centered
             size="lg"
             :title="modal_image.data ? modal_image.data.name : ''"
             body-class="p-0"
    >
        <b-row>
            <b-col cols="12"
                   class="container-image"
                   v-if="modal_image.data"
            >
                <div class="d-flex align-items-center justify-content-center h-100">

                <img :src="modal_image.data.url"
                     :alt="modal_image.data.name"
                     class="image_task"
                >
                </div>
            </b-col>

        </b-row>
        <b-row>
            <b-col class="text-center">
                <hr>
                <b-btn variant="primary"
                       @click="downloadImage"
                       size="sm"
                       class="mb-2"
                >
                    <i class="fa fa-download"/>
                    Descargar
                </b-btn>
            </b-col>
        </b-row>
    </b-modal>
</template>


<script>
import {mapState, mapActions} from 'vuex';

export default {
    name: 'modal_image',
    computed: {
        ...mapState('tasks', [
            'modal_image'
        ])
    },
    methods: {
        ...mapActions('tasks', [
            'downloadImage'
        ])
    }
};
</script>

<style>
.image_task {
    max-width: 600px;
    max-height: 400px;
}

.container-image {
    height: 400px;
}
</style>

